import { getFromLocalStorageByKey, removeFromLocalStorage, saveToLocalStorage } from './index';

export const AZURE_B2C_TOKENS = 'AZURE_B2C_TOKENS';
const AZURE_B2C_POLICY_NAME = 'AZURE_B2C_POLICY_NAME';
export const AZURE_B2C_CODE_VERIFIER = 'AZURE_B2C_CODE_VERIFIER';

export const getAuthTokens = () => {
  return getFromLocalStorageByKey(AZURE_B2C_TOKENS);
};

export const putAuthTokens = tokens => {
  localStorage.setItem(AZURE_B2C_TOKENS, JSON.stringify({ ...tokens, issuedAt: new Date() }));
};

export const deleteAuthTokens = () => {
  removeFromLocalStorage(AZURE_B2C_TOKENS);
};

export const getCodeVerifierAndRemoveFromLocalStorage = () => {
  const codeVerifier = getFromLocalStorageByKey(AZURE_B2C_CODE_VERIFIER);
  removeFromLocalStorage(AZURE_B2C_CODE_VERIFIER);
  return codeVerifier;
};

export const getAzureB2CPolicyName = () => {
  const policyName = getFromLocalStorageByKey(AZURE_B2C_POLICY_NAME);

  return policyName;
};

export const setAzureB2CPolicyName = name => {
  saveToLocalStorage(AZURE_B2C_POLICY_NAME, name);
};
